import { GoogleGenerativeAI } from '@google/generative-ai';

const apiKey = import.meta.env?.VITE_GEMINI_API_KEY;

if (!apiKey) {
  console.warn('Gemini API key not found. Gemini features will not work.');
}

let genAI = null;

try {
  if (apiKey) {
    genAI = new GoogleGenerativeAI(apiKey);
  }
} catch (error) {
  console.error('Failed to initialize Gemini client:', error);
}

export default genAI;